module.exports = __webpack_public_path__ + "img/arrow-right-fat.f9a9dc9.svg";